/**
 * @generated SignedSource<<1b9d67ee56424b3dfd65c2b7ee1da5ac>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskCmsTopic_viewer$data = {
  readonly getHelpTopic: {
    readonly instructionalText: string | null;
    readonly label: string | null;
    readonly primaryCta: {
      readonly label: string | null;
      readonly link: string | null;
    } | null;
    readonly showContactButton: boolean | null;
    readonly supportCenterLink: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"UpdatedContactSellerForm_getHelpTopic">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskContactBuyer_viewer" | "GetHelpZendeskSellerItemTile_viewer" | "GetHelpZendeskSellerOrderTile_viewer" | "ItemReturnPolicy_viewer" | "TrackingDetails_viewer">;
  readonly " $fragmentType": "GetHelpZendeskCmsTopic_viewer";
};
export type GetHelpZendeskCmsTopic_viewer$key = {
  readonly " $data"?: GetHelpZendeskCmsTopic_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskCmsTopic_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isSeller"
    },
    {
      "kind": "RootArgument",
      "name": "orderId"
    },
    {
      "kind": "RootArgument",
      "name": "topicKey"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GetHelpZendeskCmsTopic_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "isSeller",
          "variableName": "isSeller"
        },
        {
          "kind": "Variable",
          "name": "orderId",
          "variableName": "orderId"
        },
        {
          "kind": "Variable",
          "name": "topicKey",
          "variableName": "topicKey"
        }
      ],
      "concreteType": "GetHelpTopic",
      "kind": "LinkedField",
      "name": "getHelpTopic",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "instructionalText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "GetHelpTopicTypePrimaryCta",
          "kind": "LinkedField",
          "name": "primaryCta",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "link",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "supportCenterLink",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showContactButton",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "UpdatedContactSellerForm_getHelpTopic"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ItemReturnPolicy_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TrackingDetails_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskContactBuyer_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskSellerItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GetHelpZendeskSellerOrderTile_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "8746af26a0b6d977cd7aa70294edcc52";

export default node;
